import { KEYWORD } from '../constants';

const buildFieldName = (relations, fieldValue, stringProps) => {
  const field = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;
  if (!field) return null;

  let updatedField = field;

  if (field.includes('.')) {
    const [relationName, relationProp] = field.split('.');

    const [relation] = relations.filter(({ localField }) => localField === relationName);
    const { entityIdentifier = '' } = relation || {};
    if (entityIdentifier && entityIdentifier !== relationName)
      updatedField = `${entityIdentifier}.${relationProp}`;
  }
  return stringProps.includes(updatedField) ? `${field}.${KEYWORD}` : field;
};

const getSortbyFieldName = (relations, sortby, stringProps, isSortbyArray) =>
  isSortbyArray
    ? buildFieldName(relations, sortby[0], stringProps)
    : buildFieldName(relations, sortby, stringProps);

export default getSortbyFieldName;
